<template>
  <div class="cs-icon-overlay" :class="overlayClasses" @click="handleClick">
    <slot />
  </div>
</template>

<script>
import { inArray } from 'lib/component/validators';

export default {
  name: 'CSIconOverlay',
  props: {
    type: {
      type: String,
      validator: inArray(['default', 'primary', 'secondary', 'project']),
      default() {
        return 'default';
      },
    },
    hover: {
      type: Boolean,
      default() {
        return false;
      },
    },
    active: {
      type: Boolean,
      default() {
        return false;
      },
    },
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
    },
    loading: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  computed: {
    overlayClasses() {
      return {
        [this.type]: true,
        hover: this.hover,
        active: this.active,
        disabled: this.disabled,
        loading: this.loading,
      };
    },
  },
  methods: {
    handleClick() {
      if (this.disabled || this.loading) {
        return;
      }

      this.$emit('click');
    },
  },
};
</script>
<style lang="sass" scoped>
  // @import '~containers/app/styles/main.sass'

  .cs-icon-overlay
    position: relative
    cursor: pointer

    &:after
      content: ''
      width: 100%
      height: 100%
      position: absolute
      top: 50%
      left: 50%
      border-radius: 50%
      transition: all linear .1s
      transform: translate(-50%, -50%)

    *
      z-index: 100

    &.default
      &:after
        padding: 0px

        #{theme('obsidian')} &
          background-color: #181822

        #{theme('eclipse')} &
          background-color: #e5e5e5

      &:hover,
      &.hover
        &:after
          padding: 20px

          #{theme('obsidian')} &
            background-color: rgba(55, 56, 85, 1)

          #{theme('eclipse')} &
            background-color: rgba(33, 33, 33, 0.1)

      &:active,
      &.active
        &:after
          padding: 20px

          #{theme('obsidian')} &
            background-color: #27283c

          #{theme('eclipse')} &
            background-color: #fff

      &:disabled,
      &.disabled
        opacity: .2
        cursor: default

        &:hover
          &:after
            background-color: transparent

      &.loading
        cursor: wait

        *
          opacity: 0

        &:after
          padding: 20px
          background-size: 400% 400%
          animation: loading 3s ease infinite

          #{theme('obsidian')} &
            background-image: linear-gradient(270deg, rgba(55, 56, 85, 1) 0%, rgba(55, 56, 85, 0) 100%)

          #{theme('eclipse')} &
            background-image: linear-gradient(270deg, rgba(33, 33, 33, 0.1) 0%, rgba(0, 0, 0, 0) 100%)

        &:hover
          &:after
            background-color: transparent

    &.primary
      &:after
        #{theme('obsidian')} &
          padding: 20px
          background-color: #27283c

        #{theme('eclipse')} &
          padding: 0
          background-color: transparent

      &:hover,
      &.hover
        &:after
          padding: 20px

          #{theme('obsidian')} &
            background-color: #373855

          #{theme('eclipse')} &
            background: linear-gradient(249.76deg, #37b55e -8.32%, #7bd3ff 108.85%), #fff
            opacity: .3

      &:active,
      &.active
        &:after
          padding: 25px
          background: linear-gradient(249.76deg, #37b55e -8.32%, #7bd3ff 108.85%), #fff

        &:hover
          &:after
            opacity: 1

      &:disabled,
      &.disabled
        opacity: .2
        cursor: default

        &:after
          padding: 20px

          #{theme('obsidian')} &
            background-color: #fff
            box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.25)
            opacity: 0.5

          #{theme('eclipse')} &
            background-color: rgba(0, 0, 0, 0.25)

        &:hover,
        &.hover,
          &:after
            #{theme('obsidian')} &
              background-color: #fff
              box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.25)
              opacity: 0.5

            #{theme('eclipse')} &
              background: none
              background-color: #000
              opacity: .25

        &:active,
        &.active
          &:after
            background: none
            background-color: #fff
            box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.25)
            opacity: 0.5

      &.loading
        cursor: wait

        *
          opacity: 0

        &:after
          padding: 20px
          background-size: 400% 400%
          animation: loading 3s ease infinite

          #{theme('obsidian')} &
            background-image: linear-gradient(270deg, rgba(55, 56, 85, 1) 0%, rgba(55, 56, 85, 0) 100%)

          #{theme('eclipse')} &
            background-image: linear-gradient(270deg, rgba(33, 33, 33, 0.1) 0%, rgba(0, 0, 0, 0) 100%)

        &:hover
          &:after
            background-color: transparent

  @keyframes loading
    0%
      background-position: 0% 50%

    50%
      background-position: 100% 50%

    100%
      background-position: 0% 50%
</style>
